<template>
    <div>
        <!-- if it needs to beshown above "read more", place it here -->
        <template v-if="show === 'all' || show === 'latest-update'">
            <p><strong>Update 12/23:</strong></p>
            <div>
                <p>
                    We met with our sending carrier and completed the next step in pushing back on these blocks. This should lead to additional feedback and dialogue with the blocking party as we work toward a resolution.
                </p>
                <p>
                    No new blocks were reported today. That said, the original three blocks were issued several days after the messages in question, so additional blocks remain possible. We and our sending carrier will continue monitoring this without interruption through the holiday, though responses from outside parties may be delayed.
                </p>
                <p>
                    <strong>We continue to recommend temporarily refraining from sending bulk messages that promote wine sales</strong> until we have more clarity. We'll share updates as they become available.
                </p>
            </div>
        </template>

        <!-- if it needs to be shown below "read more", place it here -->
        <template v-if="show === 'all' || show === 'expanded-content'">
            <p><strong>What's happened:</strong></p>
            <div class="wrapper">
                <p>
                    We've just been made aware of unusual and unexpected carrier blocks affecting three wineries in rapid succession. These reports are separate but nearly identical, and we strongly disagree with the findings. We are actively pushing back, along with our sending carrier, on the relevant telecom entities.
                </p>
                <p>
                    Carrier blocks like these require all messages from the affected business to be temporarily blocked until the issue is resolved. To be clear: <strong>only the three wineries involved are currently experiencing message delivery interruptions</strong>, and we have already contacted them directly.
                </p>
                <p>
                    However, because we received multiple similar blocks in such a short time — something we have not seen before — we want to proactively share what we're seeing so you can take steps to reduce your risk while we try to get more answers.
                </p>
            </div>

            <p><strong>What you should do right now:</strong></p>
            <div class="wrapper">
                <p>
                    Out of an abundance of caution, we recommend that you <strong>temporarily refrain from sending any bulk messages that promote wine sales</strong> until we have more clarity. If you're unsure whether a message is promoting wine sales, versus promoting something else or being informational, we recommend erring on the side of caution and not sending it for now.
                </p>
            </div>
            
            <p><strong>What we're doing:</strong></p>
            <div class="wrapper">
                <p>
                    We are in urgent contact with our sending carrier and together are pushing back on these carrier-level blocks while seeking clarification and resolution. While we're working on this without interruption, responses from telecom entities can sometimes be slow, and the holiday timing may impact their response time.
                </p>
                <p>
                    Please know that we are treating this with the highest priority and will continue to keep you informed as we learn more. We understand how frustrating this is, and our goal is to provide transparency and practical guidance while we work to resolve the situation as quickly as possible.
                </p>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'WineryCarrierAlertContent',

    props: {
        show: {
            type: String,
            default: 'all',
            validator: (value) => ['all', 'latest-update', 'expanded-content'].includes(value),
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    padding-left: 1.25rem;
}
</style>